import ViewTransactionHistoryButton from './ViewTransactionHistoryButton';

export default ViewTransactionHistoryButton;